import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Logo } from '../../components/Logo/Logo';

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    background: #2C7880;
    color: white;
    padding: inherit;
`

const ProviderHeader = ({profilePhotoURL, text, ...styleProps}) => {
    return(
        <HeaderWrapper>
            <Logo 
                logoURL={profilePhotoURL}
                size={30}
                style={{
                    display:'inline-block',
                    float:'left',
                    marginLeft:'2px'
                }} 
            />
            {text}
        </HeaderWrapper>
    )
}

export default ProviderHeader;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ProviderHeader.jsx